import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_URL_TOKEN, TenantDeviceAllowlist } from '@raptor-fe/core';
import { Observable } from 'rxjs';
import { LoadingHeaders } from '../web-loading-service/web-loading-headers';

@Injectable({
    providedIn: 'root',
})
export class TenantDeviceAllowlistService {
    private readonly http = inject(HttpClient);
    private readonly base_url = `${inject(BASE_URL_TOKEN)}v1/tenant/`;
    private httpHeadersWithNoLoading = LoadingHeaders.httpHeadersWithNoLoading();

    /**
     * Lists all approved devices for the tenant.
     */
    getAll(tenantId: string): Observable<TenantDeviceAllowlist[]> {
        return this.http.get<TenantDeviceAllowlist[]>(`${this.base_url}${tenantId}/tenantdeviceallowlist`, {
            headers: this.httpHeadersWithNoLoading,
        });
    }

    /**
     * Adds a device to the tenant's allowlist. Idempotent on (tenantId, deviceId);
     * re-adding the same deviceId preserves the original name.
     */
    add(tenantId: string, deviceId: string, name: string): Observable<TenantDeviceAllowlist> {
        return this.http.post<TenantDeviceAllowlist>(
            `${this.base_url}${tenantId}/tenantdeviceallowlist`,
            { deviceId, name },
            { headers: this.httpHeadersWithNoLoading },
        );
    }

    /**
     * Removes a device from the tenant's allowlist.
     */
    remove(tenantId: string, deviceId: string): Observable<void> {
        return this.http.delete<void>(`${this.base_url}${tenantId}/tenantdeviceallowlist/${encodeURIComponent(deviceId)}`, {
            headers: this.httpHeadersWithNoLoading,
        });
    }
}
